import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-114f99ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hidden_panel"
}

import { storeToRefs } from 'pinia';

import IconButtons from '@/components/desktop/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'HiddenPanel',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const { showPanel } = useCommonStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (!_unref(showPanel).isLeftPanel && !_unref(isImageMode))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(IconButtons)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})